import React from "react";
import * as S from "./CustomPoints.styles";

export const CustomPoints = ({
  points,
}: {
  points: {
    description: string;
    header: string;
    points: {
      category: string;
      qualifiedProducts: string;
    }[];
  };
}) => {
  return (
    <S.CustomPoints>
      <S.Description>{points.description}</S.Description>
      <S.Header>{points.header}</S.Header>
      <S.PointsContainer>
        {points.points.map((point, index) => (
          <S.CopyContainer key={`${point.category}-${index}`}>
            <S.Category>{point.category}</S.Category>{" "}
            <S.QualifiedProducts>{point.qualifiedProducts}</S.QualifiedProducts>
          </S.CopyContainer>
        ))}
      </S.PointsContainer>
    </S.CustomPoints>
  );
};
